import { render, staticRenderFns } from "./QuotationModalInfo.vue?vue&type=template&id=7a643e12&scoped=true&"
import script from "./QuotationModalInfo.vue?vue&type=script&lang=js&"
export * from "./QuotationModalInfo.vue?vue&type=script&lang=js&"
import style0 from "./QuotationModalInfo.vue?vue&type=style&index=0&id=7a643e12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a643e12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDialog,VFlex,VLayout})
